import React from 'react';

function Header() {
  return (
    <div className="sia-header">
      <div className="container-fluid" style={{ paddingLeft: '15px' }}>
        <img 
          src="/subaru-logo.png" 
          alt="Subaru" 
          className="sia-logo"
        />
      </div>
    </div>
  );
}

export default Header;
